//@ts-check

class ProfileService {
	constructor($http, Utility, $timeout, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.userDetails = null;
		this.myProfileInformation = null;
	}

	async updateDetails(userDetails) {
		let promise, promiseHandler;

		promise = new Promise((resolve, reject) => {
			promiseHandler = {
				reject,
				resolve
			};
		});

		try {
			let url = await this.InternalLinksService.getLink('UpdateUserDetails');

			if (!url) {
				await this.InternalLinksService.getLinks('links', false, true);
				url = await this.InternalLinksService.getLink('UpdateUserDetails');
			}

			const headers = this.Utility.headers;

			let results = await this.$http.post(url, userDetails, { headers });

			if ('data' in results) {
				results = results.data;
			}

			const { WasSuccessful: wasSuccessful, Data: data } = results;

			if (!wasSuccessful) {
				throw Error('Error while updating user details.');
			}

			promiseHandler.resolve(data);
		} catch (error) {
			promiseHandler.reject(error);
		}

		return promise;
	}

	async getMyProfileInformation(unitInfo) {
		const msg = 'Error while retrieving profile information';

		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!!!unitInfo) {
				throw new Error('No unit information provided...');
			}

			let url = await this.InternalLinksService.getLink('GetMyProfileInformation');

			if (!url) {
				await this.InternalLinksService.getLinks('links', false, true);
				url = await this.InternalLinksService.getLink('GetMyProfileInformation');
			}

			const headers = this.Utility.headers;
			const { SchemeReference, CardCode } = unitInfo;
			url = `${url.replace('{schemeReference}', SchemeReference)}?cardCode=${CardCode}`;

			const results = await this.$http.get(url, { headers });
			const { data } = results;
			if (data) {
				this.myProfileInformation = this._mapEmails(data);
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw new Error(msg);
			}
		} catch (err) {
			console.error(`Error received: ${err}`);
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	/**
   * @param {object} contactInfo
   */
	async updateContactDetails(contactInfo) {
		let promise, promiseHandler;
		const msg = 'Error while updating contact details';

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('UpdateContactDetails');

			if (!url) {
				await this.InternalLinksService.getLinks('links', false, true);
				url = await this.InternalLinksService.getLink('UpdateContacts');
			}

			const headers = this.Utility.headers;

			const results = await this.$http.post(url, contactInfo, { headers });
			const { WasSuccessful } = results.data;

			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw new Error(msg);
			}
		} catch (err) {
			console.error(msg, err);
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async requestChangeForMultipleUnits(cardCode) {
		const msg = 'Failed to update contact details.';

		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('RequestChangeForMultipleUnits');

			if (!url) {
				await this.InternalLinksService.getLinks('api/accounts/links', false);
				url = await this.InternalLinksService.getLink('RequestChangeForMultipleUnits');
			}

			const headers = this.Utility.headers;
			url = url.replace('{cardCode}', cardCode);

			const results = await this.$http.post(url, { headers });
			const { WasSuccessful } = results.data;
			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw new Error(msg);
			}
		} catch (error) {
			this.$timeout(() => promiseHandler.reject(`${error}:\n${error}`));
		}

		return promise;
	}

	/**
   * @param {object} addressDetails
   */
	async updateAddressDetails(addressDetails) {
		const msg = 'Failed to update contact details.';

		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});
			let url = await this.InternalLinksService.getLink('UpdateAddressDetails');

			if (!url) {
				await this.InternalLinksService.getLinks('api/accounts/links', false);
				url = await this.InternalLinksService.getLink('UpdateAddressDetails');
			}

			const headers = this.Utility.headers;
			const results = await this.$http.post(url, addressDetails, { headers });
			const { WasSuccessful } = results.data;
			if (WasSuccessful) {
				this.$timeout(() => promiseHandler.resolve());
			} else {
				throw new Error(msg);
			}
		} catch (error) {
			this.$timeout(() => promiseHandler.reject(`${error}:\n${error}`));
		}

		return promise;
	}

	_mapEmails(data) {
		const EmailAddressChanges = data.EmailAddress;

		const emailAddresses = EmailAddressChanges.map((email) => email.EmailAddress);
		const EmailAddress = emailAddresses;

		return {
			...data,
			EmailAddress,
			EmailAddressChanges
		};
	}
}

export default /* @ngInject */ ($http, Utility, $timeout, LocalStorageService, InternalLinksService) =>
	new ProfileService($http, Utility, $timeout, LocalStorageService, InternalLinksService);
